import { Component, Input, OnInit } from '@angular/core';
import { Address, AddressType } from 'src/app/shared-core/models/checkout-data.model';

@Component({
  selector: 'app-address-view',
  templateUrl: './address-view.component.html',
  styleUrls: ['./address-view.component.scss'],
})
export class AddressViewComponent implements OnInit {
  AddressType = AddressType;
  @Input() address: Address;
  constructor() {}

  ngOnInit(): void {}
}
